module.exports = __webpack_public_path__ + "img/pres_5.f1f23e11.jpg";